import React from 'react'
import { Link, useHistory } from 'react-router-dom';
import { auth } from "../../firebase";
import "./Regsiter.css";
import { useState } from 'react'




function Register() {

    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const register = event => {
        event.preventDefault()
        auth.createUserWithEmailAndPassword(email, password)
            .then(auth => {
            history.push('/')
            })
        .catch(error => alert(error.message))
    }


    return (
           <div className="login__container">
                <h1>Sign-In</h1>
                <form>
                    <h5>E-mail</h5>
                    <input type="text" value={email}
                        onChange={event => setEmail(event.target.value)} />
                
                    <h5>Password</h5>
                    <input type="password" value={password}
                        onChange={event => setPassword(event.target.value)} />

                </form>

                <p>By signing-in you agree to Wuzi's Conditions
                of Use & Sale. Please
                see our Privacy Notice, Our Cookies Notice and 
                our Interest-Based Ads Notice.
                </p>
                <button onClick={register} className="login__registerButton" >Create your Wuzi Account</button>
            </div>       
    )
}

export default Register
